import { render, staticRenderFns } from "./cookie.vue?vue&type=template&id=7996db13&"
import script from "./cookie.vue?vue&type=script&lang=js&"
export * from "./cookie.vue?vue&type=script&lang=js&"
import style0 from "./cookie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports